/**
 * Modo seguro de storage: pausa flush até recovery.
 */

import { recordStorageCorruptionDetected } from '../telemetry';

let active = false;
let reason: string | null = null;

export function enterStorageSafeMode(r: string): void {
  active = true;
  reason = r;
  recordStorageCorruptionDetected();
}

export function clearStorageSafeMode(): void {
  active = false;
  reason = null;
}

export function isStorageSafeMode(): boolean {
  return active;
}

export function getStorageSafeModeReason(): string | null {
  return reason;
}

export function _testResetStorageSafeMode(): void {
  active = false;
  reason = null;
}
